module.exports = __webpack_public_path__ + "static/media/creating-your-adset-1.a5c3e7e2.png";